/* Same REVIEWS.io Polaris integration and SKU grouping as the existing PDP. */
(() => {
  let cleanup = () => {};
  function init() {
    cleanup();
    const host = document.getElementById('ps-reviews-widget');
    const native = document.getElementById('ps-native-rating');
    if (!host || !native) return;
    const summary = document.querySelector('.review-summary');
    function syncRating() {
      const label = native.getAttribute('aria-label') || native.getAttribute('title') || '';
      const match = label.match(/([\d.]+)\s+Stars?\s*-\s*([\d,]+)\s+Reviews?/i);
      if (!match) return;
      document.getElementById('ps-review-rating').textContent = match[1];
      summary.classList.add('has-rating');
      document.getElementById('ps-review-count').textContent = `${match[2]} reviews`;
      summary.setAttribute('aria-label', `Rated ${match[1]} out of 5, ${match[2]} reviews. Read customer reviews.`);
    }
    const ratingObserver = new MutationObserver(syncRating);
    ratingObserver.observe(native, { attributes: true, childList: true, subtree: true });
    syncRating();
    const widgetObserver = new MutationObserver(() => {
      if (host.children.length) document.getElementById('ps-reviews-fallback').hidden = true;
    });
    widgetObserver.observe(host, { childList: true, subtree: true });
    if (typeof ReviewsWidget === 'function') {
      new ReviewsWidget('#ps-reviews-widget', {
        store: 'tropicaloasis.com', widget: 'polaris',
        options: {
          types: 'product_review,questions', lang: 'en', per_page: 15,
          enable_sentiment_analysis: true,
          product_review: { sku: host.dataset.sku, enable_rich_snippets: false },
          questions: { hide_if_no_results: false, enable_ask_question: true, show_dates: true, grouping: host.dataset.sku },
          header: { enable_summary: true, enable_ratings: true, enable_attributes: true, enable_image_gallery: true, enable_percent_recommended: false, enable_write_review: true, enable_ask_question: true, enable_sub_header: true, rating_decimal_places: 2 },
          filtering: { enable: true, enable_text_search: true, enable_sorting: true, enable_media_filter: true, enable_overall_rating_filter: true, enable_ratings_filters: true, enable_attributes_filters: true },
          reviews: { enable_avatar: true, enable_reviewer_name: true, enable_verified_badge: true, enable_reviewer_recommends: true, enable_images: true, enable_ratings: true, enable_helpful_vote: true, enable_date: true, enable_replies: true, combine_title_stars: true }
        },
        styles: {
          '--base-font-size': '16px', '--common-star-color': '#e65c00',
          '--common-star-disabled-color': '#dedbd4', '--medium-star-size': '22px', '--small-star-size': '19px',
          '--heading-text-color': '#022f21', '--heading-text-font-weight': '700',
          '--body-text-color': '#4b6156', '--base-font-family': 'inherit',
          '--primary-button-bg-color': '#022f21', '--primary-button-border-color': '#022f21', '--primary-button-text-color': '#ffffff',
          '--secondary-button-border-color': '#022f21', '--secondary-button-text-color': '#022f21'
        }
      });
    }
    // The existing Shopify app embed initializes this badge on window load.
    // Explicitly refresh it when the theme editor replaces this section.
    if (document.readyState === 'complete' && typeof ratingSnippet === 'function') {
      ratingSnippet('ruk_rating_snippet', { store: 'tropicaloasis.com', usePolaris: true, text: 'Reviews', linebreak: false });
    }
    cleanup = () => { ratingObserver.disconnect(); widgetObserver.disconnect(); };
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
